import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgDataOverloadIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.4}
      d="M22.489 12.452a.5.5 0 0 0-.239-.349l-6-3.464a.502.502 0 0 0-.5 0l-6 3.463a.522.522 0 0 0-.25.434v6.928a.5.5 0 0 0 .25.433l6 3.465a.524.524 0 0 0 .5 0l6-3.464a.5.5 0 0 0 .25-.433v-6.929a2 2 0 0 0-.011-.084Zm-6.989 9.61-5-2.887v-5.773l5 2.887zm.5-6.639-5-2.888 5-2.886 5 2.887zm5.5 3.753-5 2.887v-5.774l5-2.887zm-3.146 7.399a.5.5 0 0 1-.707.707L16.5 26.136V29.5a.5.5 0 0 1-1 0v-3.365l-1.146 1.146a.5.5 0 0 1-.707-.706l2-2a.505.505 0 0 1 .707 0zM16.5 2.5v3.365l1.146-1.147a.5.5 0 0 1 .707.708l-2 1.999a.5.5 0 0 1-.707 0l-2-2a.5.5 0 1 1 .707-.707L15.5 5.864V2.5a.5.5 0 0 1 1 0ZM7.425 16.354l-2 2a.5.5 0 0 1-.707-.707L5.864 16.5H2.5a.5.5 0 0 1 0-1h3.365l-1.147-1.146a.5.5 0 0 1 .708-.707l1.999 2a.505.505 0 0 1 0 .707ZM29.5 16.5h-3.365l1.146 1.146a.5.5 0 0 1-.706.707c-.035-.065-2.194-2.125-2.108-2.162a.503.503 0 0 1 .108-.545l2-2a.5.5 0 0 1 .707.707L26.136 15.5H29.5a.5.5 0 0 1 0 1Z"
    />
  </svg>
);
export default SvgDataOverloadIcon;
